const genericErrorCodes = {
  'generic-error-message': 'Ocurrió un error inesperado'
};

export default genericErrorCodes;
